import { Layout, Typography } from "antd";
import { Trans, useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router";

import { HELP_CENTER_URL } from "@/modules/help-center";
import { StaticRouteLink } from "@/modules/static-route";

import {
  isUserAccountDeactivated,
  findNonExistingUserEmail,
} from "./sso-error-page.helper";

import "./sso-error-page.style.less";

const { Title } = Typography;

const SSOErrorPage = () => {
  const { t } = useTranslation();

  const [searchParams] = useSearchParams();
  const error = searchParams.get("error_description") ?? "";

  const userAccountNotExist = findNonExistingUserEmail(error);
  const userAccountDeactivated = isUserAccountDeactivated(error);
  const defaultError = !userAccountDeactivated && !userAccountNotExist;

  return (
    <Layout data-testid="sso-error-page" className="sso-error-page">
      <main className="main-container">
        <div className="header-sso">
          <img src="/images/sso/logo_stelar.svg" alt="STELAR" />
        </div>
        <div className="content">
          <Title>{t("sso:error.title")}</Title>
          {userAccountNotExist && (
            <div className="error-message user-not-exist">
              <p>
                <Trans
                  i18nKey="sso:error.userNotExist"
                  components={{ span: <span /> }}
                  values={{ email: userAccountNotExist }}
                />
              </p>
              <img src="/images/sso/user-not-exist.svg" />
            </div>
          )}

          {userAccountDeactivated && (
            <div className="error-message deactivated">
              <p>{t("sso:error.userDeactivated")}</p>
              <img src="/images/sso/account-deactivated.svg" />
            </div>
          )}

          {defaultError && (
            <div className="error-message error-connexion">
              <img src="/images/sso/connexion-left.svg" />
              <p>{t("sso:error.connectionError")}</p>
              <img src="/images/sso/warning.svg" />
              <img src="/images/sso/connexion-right.svg" />
            </div>
          )}

          <p className="contact-support">{t("sso:error.support.message")}</p>
          <Link to={HELP_CENTER_URL}>
            <button type="button" className="btn-support">
              {t("sso:error.support.link")}
            </button>
          </Link>
          <div className="connexion">
            <StaticRouteLink route="login">
              <button type="button" className="btn-connexion">
                {t("sso:error.back")}
              </button>
            </StaticRouteLink>
          </div>
        </div>
      </main>
    </Layout>
  );
};

export default SSOErrorPage;
